import React from "react"
import { Link } from "gatsby"

import LogoIcon from "../../svg/logo.svg"

// Hooks, State
import useScrollPosition from "@react-hook/window-scroll"
import { useAppState } from "../../state/appState"

export const HomeLink = ({ navOpen }) => {
  const scrollY = useScrollPosition(60 /*fps*/)
  const { closeNav } = useAppState()
  return (
    <Link
      to="/"
      className={`fill-current transition-all ${
        scrollY < 200 && !navOpen ? "w-32 md:w-48 lg:w-52" : "w-20 md:w-32"
      }`}
      onClick={closeNav}
    >
      <LogoIcon />
    </Link>
  )
}
